import React from 'react';
import { MdGavel, MdBusiness, MdWeb, MdSecurity } from 'react-icons/md';
import { useTranslation } from '../../hooks/useTranslation';
import { Header, Footer } from '../../../portfolio/layouts/index';
import * as styles from './legalNotice.css';

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <MdGavel className={styles.headerIcon} aria-hidden="true" />
          <div>
            <h1 className={styles.title}>
              {t('legal.title')}
            </h1>
            <p className={styles.subtitle}>
              {t('legal.subtitle')}
            </p>
          </div>
        </div>
      </header>

      <main className={styles.content}>
        <article className={styles.article}>
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              <MdBusiness aria-hidden="true" />
              {t('legal.sections.editor.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.infoGrid}>
                <div className={styles.infoCard}>
                  <h3 className={styles.infoTitle}>{t('legal.sections.editor.name')}</h3>
                  <p>Jean-François Chaussoy</p>
                </div>
                
                <div className={styles.infoCard}>
                  <h3 className={styles.infoTitle}>{t('legal.sections.editor.status')}</h3>
                  <p>{t('legal.sections.editor.statusValue')}</p>
                </div>
                
                <div className={styles.infoCard}>
                  <h3 className={styles.infoTitle}>{t('legal.sections.editor.address')}</h3>
                  <p>
                    France<br />
                    {t('legal.sections.editor.addressNote')}
                  </p>
                </div>
                
                <div className={styles.infoCard}>
                  <h3 className={styles.infoTitle}>{t('legal.sections.editor.contact')}</h3>
                  <p>
                    <a href="mailto:jf.c.webcraft@gmail.com">
                      jf.c.webcraft@gmail.com
                    </a>
                  </p>
                </div>
                
                <div className={styles.infoCard}>
                  <h3 className={styles.infoTitle}>{t('legal.sections.editor.website')}</h3>
                  <p>
                    <a href="https://jfc-webcraft.fr" target="_blank" rel="noopener noreferrer">
                      https://jfc-webcraft.fr
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              <MdWeb aria-hidden="true" />
              {t('legal.sections.hosting.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.hostingInfo}>
                <div className={styles.hostingCard}>
                  <h3 className={styles.hostingTitle}>Frontend & Backend</h3>
                  <p><strong>Hostinger VPS</strong></p>
                  <p>HOSTINGER INTERNATIONAL LTD</p>
                  <p>61 Lordou Vironos Street, 6023 Larnaca, Cyprus</p>
                  <p>
                    <a href="https://www.hostinger.com" target="_blank" rel="noopener noreferrer">
                      https://www.hostinger.com
                    </a>
                  </p>
                </div>
                
                <div className={styles.hostingCard}>
                  <h3 className={styles.hostingTitle}>Base de données</h3>
                  <p><strong>PostgreSQL (auto-hébergé)</strong></p>
                  <p>Hébergée sur le serveur du site, au sein de l'Union Européenne.</p>
                  <p>Aucune donnée n'est confiée à un service de base de données tiers.</p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {t('legal.sections.property.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.propertyNotice}>
                <p>{t('legal.sections.property.content1')}</p>
                <p>{t('legal.sections.property.content2')}</p>
                
                <h3 className={styles.subsectionTitle}>{t('legal.sections.property.exceptions.title')}</h3>
                <ul className={styles.exceptionsList}>
                  <li>{t('legal.sections.property.exceptions.icons')}</li>
                  <li>{t('legal.sections.property.exceptions.fonts')}</li>
                  <li>{t('legal.sections.property.exceptions.libraries')}</li>
                  <li>{t('legal.sections.property.exceptions.images')}</li>
                </ul>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {t('legal.sections.responsibility.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.responsibilityContent}>
                <div className={styles.disclaimer}>
                  <h3>{t('legal.sections.responsibility.limitations.title')}</h3>
                  <p>{t('legal.sections.responsibility.limitations.content1')}</p>
                  <p>{t('legal.sections.responsibility.limitations.content2')}</p>
                </div>
                
                <div className={styles.disclaimer}>
                  <h3>{t('legal.sections.responsibility.accuracy.title')}</h3>
                  <p>{t('legal.sections.responsibility.accuracy.content')}</p>
                </div>
                
                <div className={styles.disclaimer}>
                  <h3>{t('legal.sections.responsibility.links.title')}</h3>
                  <p>{t('legal.sections.responsibility.links.content')}</p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              <MdSecurity aria-hidden="true" />
              {t('legal.sections.data.title')}
            </h2>
            <div className={styles.sectionContent}>
              <p>{t('legal.sections.data.intro')}</p>
              
              <div className={styles.dataInfo}>
                <div className={styles.dataCard}>
                  <h3>{t('legal.sections.data.technical.title')}</h3>
                  <ul>
                    <li>{t('legal.sections.data.technical.logs')}</li>
                    <li>{t('legal.sections.data.technical.analytics')}</li>
                    <li>{t('legal.sections.data.technical.preferences')}</li>
                  </ul>
                </div>
                
                <div className={styles.dataCard}>
                  <h3>{t('legal.sections.data.contact.title')}</h3>
                  <ul>
                    <li>{t('legal.sections.data.contact.name')}</li>
                    <li>{t('legal.sections.data.contact.email')}</li>
                    <li>{t('legal.sections.data.contact.message')}</li>
                  </ul>
                </div>
              </div>
              
              <div className={styles.gdprLink}>
                <p>
                  {t('legal.sections.data.gdpr')}
                  <a href="/legal/privacy" className={styles.privacyLink}>
                    {t('legal.sections.data.privacyPolicy')}
                  </a>
                </p>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              <MdSecurity aria-hidden="true" />
              {t('legal.sections.thirdParty.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.thirdPartyInfo}>
                <p>{t('legal.sections.thirdParty.intro')}</p>
                
                <div className={styles.servicesList}>
                  <div className={styles.serviceCard}>
                    <h3>{t('legal.sections.thirdParty.emailjs.name')}</h3>
                    <p>{t('legal.sections.thirdParty.emailjs.purpose')}</p>
                    <a href={t('legal.sections.thirdParty.emailjs.website')} target="_blank" rel="noopener noreferrer">
                      {t('legal.sections.thirdParty.emailjs.website')}
                    </a>
                  </div>
                  
                  <div className={styles.serviceCard}>
                    <h3>{t('legal.sections.thirdParty.recaptcha.name')}</h3>
                    <p>{t('legal.sections.thirdParty.recaptcha.purpose')}</p>
                    <a href={t('legal.sections.thirdParty.recaptcha.website')} target="_blank" rel="noopener noreferrer">
                      {t('legal.sections.thirdParty.recaptcha.website')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {t('legal.sections.applicable.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.lawInfo}>
                <p>{t('legal.sections.applicable.content1')}</p>
                <p>{t('legal.sections.applicable.content2')}</p>
                
                <div className={styles.jurisdictionInfo}>
                  <h3>{t('legal.sections.applicable.jurisdiction.title')}</h3>
                  <p>{t('legal.sections.applicable.jurisdiction.content')}</p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {t('legal.sections.contact.title')}
            </h2>
            <div className={styles.sectionContent}>
              <div className={styles.contactSection}>
                <p>{t('legal.sections.contact.intro')}</p>
                
                <div className={styles.contactMethods}>
                  <div className={styles.contactCard}>
                    <h3>{t('legal.sections.contact.email.title')}</h3>
                    <p>
                      <a href="mailto:jf.c.webcraft@gmail.com">
                        jf.c.webcraft@gmail.com
                      </a>
                    </p>
                    <p className={styles.responseTime}>
                      {t('legal.sections.contact.email.response')}
                    </p>
                  </div>
                  
                  <div className={styles.contactCard}>
                    <h3>{t('legal.sections.contact.form.title')}</h3>
                    <p>
                      <a href="/#contact">
                        {t('legal.sections.contact.form.link')}
                      </a>
                    </p>
                    <p className={styles.responseTime}>
                      {t('legal.sections.contact.form.response')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
      
      <footer className={styles.footer}>
        <p className={styles.footerText}>
          {t('legal.footer.lastUpdate')}: 7 août 2025
        </p>
        <div className={styles.footerLinks}>
          <a href="/legal/privacy" className={styles.footerLink}>
            {t('legal.footer.privacy')}
          </a>
          <span className={styles.separator}>•</span>
          <a href="/legal/cookies" className={styles.footerLink}>
            {t('legal.footer.cookies')}
          </a>
        </div>
      </footer>
    </div>
    <Footer />
    </>
  );
};

export default LegalNotice;
